import * as React from "react";
import type { SVGProps } from "react";
const SvgLock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 11a1 1 0 1 0 2 0zm1-4H6zm5-5V1zm4 9a1 1 0 1 0 2 0zM5 12h14v-2H5zm14 0a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zm1 1v7h2v-7zm0 7a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-1 1H5v2h14zM5 21a1 1 0 0 1-1-1H2a3 3 0 0 0 3 3zm-1-1v-7H2v7zm0-7a1 1 0 0 1 1-1v-2a3 3 0 0 0-3 3zm4-2V7H6v4zm0-4a4 4 0 0 1 1.172-2.828L7.757 2.757A6 6 0 0 0 6 7zm1.172-2.828A4 4 0 0 1 12 3V1a6 6 0 0 0-4.243 1.757zM12 3a4 4 0 0 1 2.828 1.172l1.415-1.415A6 6 0 0 0 12 1zm2.828 1.172A4 4 0 0 1 16 7h2a6 6 0 0 0-1.757-4.243zM16 7v4h2V7z"
    />
  </svg>
);
export default SvgLock;
